/** Planšetės APK (Capacitor) — kiosko prisijungimas. */
export const KIOSK_LOGIN_PATH = '/login/meistrai';

export function isCapacitorNative(): boolean {
  if (typeof window === 'undefined') return false;
  const cap = (window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return Boolean(cap?.isNativePlatform?.());
}

/** Darbo diena pradėta per planšetės kiosko prisijungimą (6 sk. kodas). */
export function isKioskWorkdayStart(startVia: string | null | undefined): boolean {
  return startVia === 'kiosk-tablet' || startVia === 'kiosk';
}

/**
 * @deprecated Brigados PIN registracija pašalinta — kiekvienas meistras jungiasi 6 sk. kodu.
 * Palikta suderinamumui; visada true (PIN UI nerodomas).
 */
export function shouldHideBrigadeRegistration(_opts?: {
  isCapacitor?: boolean;
  startVia?: string | null;
}): boolean {
  return true;
}
